import React from 'react';
import withApi from '../bridge/withApi';
import { ACTIVATE_ASSET } from '../../api/redux-bridge/bridge-methods';
import PropTypes from 'prop-types';

class AssetActivator extends React.Component {
  state = {
    activated: false,
  };

  static propTypes = {
    vbid: PropTypes.string.isRequired,
  };

  componentDidMount() {
    this.props
      .callBridgeApi(ACTIVATE_ASSET, {
        vbid: this.props.vbid,
        active: true,
      })
      // If there's an error, the page will handle it when it tries to
      // render the book content and can't
      .catch(() => {})
      .then(() => this.setActivated());
  }

  setActivated() {
    this.setState({
      activated: true,
    });
  }

  render() {
    if (this.state.activated) {
      return this.props.children;
    }
    return null;
  }
}

export default withApi(AssetActivator);

export const AssetActivatorTest = AssetActivator;



// WEBPACK FOOTER //
// ./src/app/ui/bridge/AssetActivator.js